{
  "headings": {
    "login": "Faça o login",
    "forgotten": "Esqueci minha senha",
    "confirmation": "E-mail enviado",
    "sending": "Envio de e-mail...",
    "setPass": "Defina sua senha",
    "startYourFreeTrial": "Comece seu teste gratuito."
  },
  "subHeadings": {
    "freeTrial": "Teste gratuito de 30 dias. Não é necessário cartão de crédito.",
    "login": "Para acessar sua conta Iventis, comece inserindo seu endereço de e-mail.",
    "forgotten": "Digite o endereço de e-mail vinculado à sua conta Iventis e enviaremos um e-mail para redefinir sua senha.",
    "confirmation": "Verifique seu e-mail para obter um link para redefinir sua senha. Pode levar até 10 minutos para chegar.",
    "confirmationCode": "Verifique seu e-mail para obter um código de verificação para sua nova conta. Pode levar até 10 minutos para chegar.",
    "setPass": "Insira uma nova senha para sua conta abaixo."
  },
  "labels": {
    "firstName": "Primeiro nome",
    "lastName": "Último nome",
    "projectName": "Nome do projeto",
    "email": "Endereço de e-mail",
    "password": "Senha",
    "confirmPass": "Repita a senha",
    "verificationCode": "Código de verificação"
  },
  "placeholders": {
    "email": "Digite seu endereço de e-mail",
    "password": "Digite sua senha",
    "passwordCreate": "Digite a senha",
    "passwordConfirm": "Digite a senha novamente"
  },
  "links": {
    "signIn": "Entrar",
    "forgotPass": "Esqueci minha senha",
    "sendAgain": "Enviar novamente",
    "termsAndCo": "Termos e condições",
    "back": "Voltar",
    "register": "Registre-se",
    "loginWithEmail": "Em vez disso, faça login com e-mail",
    "loginWithSingleSignOn": "Login com login único",
    "loginWithMicrosoft": "Faça login com sua conta da Microsoft"
  },
  "options": {
    "alreadyHaveAccount": "Já tem uma conta Iventis?",
    "dontHaveAccount": "Não tem um {{ ssoProviderName }}",
    "dontHaveIventis": "Não tem uma conta Iventis?",
    "rememberDetails": "Lembrar meus detalhes",
    "notReceived": "Não recebeu um e-mail?",
    "consentTos1": "Ao criar esta conta, eu concordo com a",
    "consentTos2": "da plataforma Iventis.",
    "verified": "Código verificado com sucesso! Sua conta agora está ativa."
  },
  "passwordConditions": {
    "min8characters": "Mínimo de 8 caracteres",
    "lowercaseLetter": "Contém uma letra minúscula",
    "uppercaseLetter": "Contém uma letra maiúscula",
    "digit": "Contém um número"
  },
  "buttons": {
    "continue": "Continuar",
    "login": "Faça o login",
    "sendLink": "Enviar link de redefinição",
    "createAccount": "Criar conta"
  },
  "footer": {
    "terms": "Termos de serviço",
    "policy": "Política de privacidade",
    "contact": "Entre em contato conosco"
  },
  "error": {
    "invalidCode": "Código inválido.",
    "unknownError": "Algo deu errado",
    "failed": "Falha ao definir a senha. Por favor, tente novamente.",
    "required": "Obrigatório",
    "invalid": "Endereço de e-mail inválido",
    "cantFindEmail": "Não conseguimos encontrar uma conta Iventis vinculada a esse endereço de e-mail. Tente novamente ou crie uma conta.",
    "passwordTooLong": "A senha pode ter no máximo 64 caracteres",
    "passwordsMustMatch": "As senhas não coincidem",
    "mustAgreeToTC": "Para criar uma conta, você deve aceitar nossos Termos e Condições",
    "resetPasswordLinkInvalidTitle": "Link expirado",
    "resetPasswordLinkInvalid": "O link para redefinir sua senha era inválido ou expirou. Enviamos um novo link para o endereço de e-mail associado à sua conta. Se você não receber um novo link, tente usar o link “senha esquecida” abaixo ou entre em contato",
    "emailInUse": {
      "0": "Este e-mail já está em uso.",
      "1": "Clique aqui",
      "2": "para fazer login"
    }
  }
}